import { render, staticRenderFns } from "./ManageTreatmentSelect.vue?vue&type=template&id=2775d304&scoped=true"
import script from "./ManageTreatmentSelect.vue?vue&type=script&lang=js"
export * from "./ManageTreatmentSelect.vue?vue&type=script&lang=js"
import style0 from "./ManageTreatmentSelect.vue?vue&type=style&index=0&id=2775d304&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2775d304",
  null
  
)

export default component.exports